import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { IWell } from 'src/Interfaces/WellInterface';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import { ITest } from '../../../Interfaces/TestInterface';
import AppNav from './AppNav';
import './Sidebar.scss';
import WorkflowNav from './WorkflowNav';




@inject('stores')
@observer
class Sidebar extends React.Component {
    public props: any;
    private tests: ITest[] = [];
    public testDisposer: any;
    public TestsStore: any;
    public WellsStore: WellsStore;
    private UserStore: UserStore;

    public state = {
        stores: {
            UserStore: {}
        },
        testList: this.tests
    };

    constructor(props: any) {
        super(props);

        this.TestsStore = this.props.stores.TestsStore;
        this.WellsStore = this.props.stores.WellsStore;
        this.UserStore = this.props.stores.UserStore;
    }

    public componentDidMount() {
        this.createDisposers();
        const wellId = this.props.match.params.wellId;
        if ( wellId && wellId !== 'new' ) {
            this.WellsStore.getWellDetails(wellId).then((well: IWell) => {
                if (this.UserStore.hasPermission("Permissions.WellTests.Read.All")) {
                    this.TestsStore.getTests(wellId);
                } else if (this.UserStore.hasPermission("Permissions.WellTests.Read.Assigned")
                    && well.engineers.some(eng => eng.id === this.UserStore.user.id)                
                ) {
                    this.TestsStore.getTests(wellId);
                } else {
                    this.setState({testList: []});
                }
            });
        }
    }

    public createDisposers() {
        this.testDisposer = intercept(this.TestsStore, 'tests', (change: any) => {
            this.setState({
                testList: change.newValue
            });
            return change;
        });
    }

    public componentWillUnmount() {
        this.testDisposer();
    }
    public componentWillReceiveProps(nextProps: any) {
        const wellId = this.props.match.params.wellId;
        const newWellId = nextProps.match.params.wellId;

        if (newWellId && newWellId !== 'new' && (!wellId || wellId !== newWellId)) {
            this.WellsStore.getWellDetails(newWellId).then((well: IWell) => {
                if (this.UserStore.hasPermission("Permissions.WellTests.Read.All")) {
                    this.TestsStore.getTests(newWellId);
                } else if (this.UserStore.hasPermission("Permissions.WellTests.Read.Assigned")
                    && well.engineers.some(eng => eng.id === this.UserStore.user.id)                
                ) {
                    this.TestsStore.getTests(newWellId);
                } else {
                    this.setState({testList: []});
                }
            });
        } else if(!newWellId) {
            this.setState({
                testList: []
            });
        }
    }

    public render() {
        const well = this.WellsStore.well ? this.WellsStore.well : new IWell();
        return(
            <div
                id="sidebar"
                className="Sidebar"
                style={ this.props.expanded ?
                        { width: 215 } :
                        { width: 40 }
                    }>
                    <AppNav expanded={this.props.expanded} testList={this.state.testList}/>
                    { this.props.expanded &&
                        <WorkflowNav well={well} testList={this.state.testList}/>
                    }
            </div>
        );
    }
}

export default withRouter(Sidebar);



// WEBPACK FOOTER //
// ./src/Components/Main/Sidebar/Sidebar.tsx